/* ══════════════════════════════════════════════════════
   RedEvidence — Flashlight Cursor Effect (Desktop only)
   ══════════════════════════════════════════════════════ */

(function() {
  const fl = document.getElementById('flashlight');
  if (!fl) return;

  // Skip touch devices
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

  let fx = 0, fy = 0, mx = 0, my = 0;
  let isActive = false;

  // Collect all dark sections
  const darkSelectors = '.section-dark,.section-darker,.re-hero,.quote-section,.cta-final,.redacted-section,.waitlist-section,.re-section,.re-evidence,.re-footer';

  function isOverDarkSection(x, y) {
    const sections = document.querySelectorAll(darkSelectors);
    for (const sec of sections) {
      const r = sec.getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
        return true;
      }
    }
    return false;
  }

  document.addEventListener('mousemove', e => {
    mx = e.clientX;
    my = e.clientY;

    const over = isOverDarkSection(mx, my);
    if (over && !isActive) {
      isActive = true;
      fl.classList.add('active');
    } else if (!over && isActive) {
      isActive = false;
      fl.classList.remove('active');
    }
  });

  (function animate() {
    fx += (mx - fx) * 0.08;
    fy += (my - fy) * 0.08;
    fl.style.left = fx + 'px';
    fl.style.top = fy + 'px';
    requestAnimationFrame(animate);
  })();
})();
